import { SVGProps } from 'react';

const SvgHelp = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
        <path d="M6.3 11.2h1.4V9.8H6.3v1.4ZM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Zm0 12.6A5.607 5.607 0 0 1 1.4 7c0-3.087 2.513-5.6 5.6-5.6 3.087 0 5.6 2.513 5.6 5.6 0 3.087-2.513 5.6-5.6 5.6Zm0-9.8a2.8 2.8 0 0 0-2.8 2.8h1.4a1.4 1.4 0 0 1 2.8 0c0 1.4-2.1 1.225-2.1 3.5h1.4c0-1.575 2.1-1.75 2.1-3.5A2.8 2.8 0 0 0 7 2.8Z" />
    </svg>
);
export default SvgHelp;
